import { fetchApplicationInfo, fetchApplications, applyCourse } from "@/api/profile";

export default {
  namespaced: true,
  state: {
    applications: [],
    applicationInfo: {},
    hasError: {},
    lastApplication: null,
  },

  mutations: {
    SET_APPLICATION_DATA(state, payload) {
      state.applications = payload;
    },
    SET_APPLICATION_INFO(state, payload) {
      state.applicationInfo = payload;
    },
    SET_LAST_APPLICATION(state, payload) {
      state.lastApplication = payload;
    },
    ADD_APPLICATION(state, payload) {
      state.applications.push(payload);
    },
    SET_ERROR(state, status) {
      state.hasError = status;
    },
    CLEAR_ERROR(state) {
      state.hasError = {};
    },
  },

  actions: {
    async loadApplications({ commit }) {
      try {
        commit('CLEAR_ERROR');
        const response = await fetchApplications();
        commit("SET_APPLICATION_DATA", response.data);
        return response;
      } catch (error) {
        commit("SET_ERROR", error);
        throw error;
      }
    },
    async loadApplicationInfo({ commit }, payload) {
      try {
        commit('CLEAR_ERROR');
        const response = await fetchApplicationInfo(payload);
        commit("SET_APPLICATION_INFO", response.data);
        return response;
      } catch (error) {
        commit("SET_ERROR", error);
        throw error;
      }
    },
    async sendApplication({ commit }, data) {
      try {
        commit('CLEAR_ERROR');
        const response = await applyCourse(data);
        
        // Сохраняем информацию о последней отправленной заявке
        commit("SET_LAST_APPLICATION", {
          data: response.data,
          timestamp: new Date().toISOString()
        });
        
        // Если нужно, можно сразу добавить в список заявок
        commit("ADD_APPLICATION", response.data);
        
        return response;
      } catch (error) {
        commit("SET_ERROR", error);
        throw error;
      }
    }
  },

  getters: {
    applications: (state) => state.applications,
    applicationInfo: (state) => state.applicationInfo,
    lastApplication: (state) => state.lastApplication,
    hasError: (state) => state.hasError,
    isLoading: (state) => state.isLoading,
  },
};
